import React from 'react';

export const GmailIconBorderless = (): React.JSX.Element => (
	<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_2230_19362)">
			<path
				d="M0.954545 11.25H3.18182V5.84089L0 3.45453V10.2954C0 10.8236 0.427955 11.25 0.954545 11.25Z"
				fill="#4285F4"
			/>
			<path
				d="M10.8182 11.25H13.0454C13.5736 11.25 14 10.822 14 10.2954V3.45453L10.8182 5.84089"
				fill="#34A853"
			/>
			<path
				d="M10.8182 1.70457V5.84093L14 3.45457V2.18184C14 1.00139 12.6525 0.328431 11.7091 1.03639"
				fill="#FBBC04"
			/>
			<path
				d="M3.18182 5.84089V1.70453L7.00001 4.56817L10.8182 1.70453V5.84089L7.00001 8.70453"
				fill="#EA4335"
			/>
			<path
				d="M0 2.18184V3.45457L3.18182 5.84093V1.70457L2.29091 1.03639C1.34591 0.328431 0 1.00139 0 2.18184Z"
				fill="#C5221F"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2230_19362">
				<rect width="14" height="10.5" fill="white" transform="translate(0 0.75)" />
			</clipPath>
		</defs>
	</svg>
);
